import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';
import { MicroLabel } from './micro-label';

/**
 * The standard card: --card surface, one hairline border, 6px radius, no shadow.
 * `subtitle` is always mono - it is system-authored metadata, never prose.
 */
export function Panel({
  title,
  subtitle,
  action,
  children,
  className,
  bodyClassName,
  accent
}: {
  title?: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
  children?: ReactNode;
  className?: string;
  bodyClassName?: string;
  /** Draws the border in the accent color - used by "Needs your action". */
  accent?: boolean;
}) {
  return (
    <section className={cn('rounded border bg-card', accent ? 'border-primary' : 'border-border', className)}>
      {(title || action) && (
        <header className={cn('flex items-start justify-between gap-4 px-5 pt-4', subtitle ? 'pb-3' : 'pb-4')}>
          <div className="grid gap-1">
            {title ? <h2 className="text-[15px] font-medium text-foreground">{title}</h2> : null}
            {subtitle ? <MicroLabel size="xs">{subtitle}</MicroLabel> : null}
          </div>
          {action}
        </header>
      )}
      <div className={cn(title || action ? 'px-5 pb-5' : 'p-5', bodyClassName)}>{children}</div>
    </section>
  );
}
